import { ListItemCard } from '@monorepo/shared/componentsV2/ListItemCard';
import { selectWidth } from '@monorepo/shared/componentsV2/styled/form';
import { cardBorder } from '@monorepo/shared/styles/card';
import { bodyMedium } from '@monorepo/shared/styles/text';
import styled from 'styled-components';

export const StyledH3 = styled.h3`
  margin-top: 0;
`;

export const StyledDescription = styled.div`
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.colors.gray666};
`;

export const StyledConditionsContainer = styled.div`
  ${cardBorder}
  max-width: 45rem;
  padding: 1.5rem 0.5rem 0 1rem;
  background: ${({ theme }) => theme.colors.grayf4};
`;

export const StyledConditionLabel = styled.div`
  ${bodyMedium}
  color: ${({ theme }) => theme.colors.gray333};
`;

export const StyledConditionProperty = styled(ListItemCard)`
  width: ${selectWidth};
  margin-top: 0.125rem;
`;

export const StyledEqualText = styled.div`
  margin-top: 1.7rem;
`;
